module.exports = {"440515001":"凤翔街道","440515002":"广益街道","440515003":"澄华街道","440515100":"上华镇","440515101":"隆都镇","440515102":"莲下镇","440515103":"莲上镇","440515104":"溪南镇","440515105":"东里镇","440515106":"盐鸿镇","440515107":"莲华镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440515.json
// module id = 2109
// module chunks = 0